import * as THREE from 'three';

export default class TextMesh{

    constructor(config) {

        let defaultConfig = {
            message:"1",
            borderThickness: 0,
            fontface: "Arial",
            fontsize: 3,
            scale:1,
            borderColour: "rgba( 255, 255, 255, 0 )",
            textBGColour: "rgba( 233, 129, 127, 0 )",
            textColour: "rgba(255, 255, 255, 1)",
            canvaswidth:1000
        }

        this.config = deepmerge(defaultConfig, config);
        return this.makeTextSprite(this.config.message);

    };

    makeTextSprite( message ){

        this.canvas = document.createElement('canvas');

        this.canvas.width  = this.config.canvaswidth;
        this.canvas.height = 150;

        this.ctx = this.canvas.getContext('2d');
        this.ctx.font         = (Math.round(this.config.fontsize * 1.5)) + "rem " + this.config.fontface;
        this.ctx.textAlign    = "center";

        // get size data (height depends only on font size)
        let metrics   = this.ctx.measureText( message );
        let textWidth = Math.round(metrics.width);

        this.ctx.fillStyle = this.config.borderColour;
        this.ctx.fillRect( 0, 0, this.canvas.width, this.canvas.height );

        this.ctx.clearRect( this.config.borderThickness, this.config.borderThickness, this.canvas.width - (this.config.borderThickness * 2), this.canvas.height - (this.config.borderThickness * 2) );
        this.ctx.fillStyle = this.config.textBGColour;
        this.ctx.fillRect( this.config.borderThickness, this.config.borderThickness, this.canvas.width - (this.config.borderThickness * 2), this.canvas.height - (this.config.borderThickness * 2) );

        // reset the font settings as lost on canvas resize

        this.ctx.font      = this.converRemToPixel(this.config.fontsize) + "px " + this.config.fontface;
        this.ctx.textAlign = "center";
        this.ctx.fillStyle = this.config.textColour;
        this.ctx.textBaseline = 'middle';
        this.ctx.imageSmoothingEnabled = false;
        this.ctx.webkitImageSmoothingEnabled = false;
        this.ctx.msImageSmoothingEnabled = false;
        this.ctx.oImageSmoothingEnabled = false;

        this.ctx.fillText( message, Math.round(this.canvas.width / 2), Math.round(this.ctx.canvas.height / 2) * 1.1, this.ctx.canvas.width);


        let texture = new THREE.Texture(this.canvas);
        let mat = new THREE.MeshLambertMaterial({
            map: texture,
            emissive:false,
            fog:true,
            transparent:true
        });


        mat.map.needsUpdate = true;

        let text = new THREE.Mesh( new THREE.PlaneBufferGeometry(this.ctx.canvas.width, this.ctx.canvas.height), mat );
        text.scale.set(1*this.config.scale, 1*this.config.scale, 1);

        return text;

    }

    converRemToPixel(rem){
        let htmlFont = $("html").css("font-size");
        htmlFont = htmlFont.replace("px", "");
        return rem * htmlFont;
    }
    getTextSize( font, text ){
        let f = font || '1rem arial',
            o = $('<div>' + text + '</div>')
                .css({'position': 'absolute', 'float': 'left', 'white-space': 'nowrap', 'visibility': 'hidden', 'font': f})
                .appendTo($('body')),
            w = o.width();
        let h = o.height();

        o.remove();

        w = this.nearestPow2(Math.round(w));
        h = this.nearestPow2(Math.round(h));

        return {height: h, width: Math.round(w)};
    }


    roundRect(context, x, y, w, h, r) {
        context.beginPath(); context.moveTo(x + r, y); context.lineTo(x + w - r, y); context.quadraticCurveTo(x + w, y, x + w, y + r); context.lineTo(x + w, y + h - r); context.quadraticCurveTo(x + w, y + h, x + w - r, y + h); context.lineTo(x + r, y + h); context.quadraticCurveTo(x, y + h, x, y + h - r); context.lineTo(x, y + r); context.quadraticCurveTo(x, y, x + r, y); context.closePath(); context.fill(); context.stroke();
    }

    nearestPow2( num ){
        return Math.pow( 2, Math.round( Math.log( num ) / Math.log( 2 ) ) );
    }


}


